<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("costeDeProductosPorAgencias")}}</li>
                    </ol>
                </nav>
            </div>

            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                :conBusquedaPorHoras="true"
                :hoursfrom="hoursfrom"
                :hoursto="hoursto"
                id="cabecera"
                :conTodos="true"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    {{ $t('permisoControlModulos') }}
                </div>
            </template>
            <template v-else-if="list.length>0 && respuesta">
                <div class="col-md-6" style="text-align: center">
                    <p style="font-size: 20px; margin-bottom: 10px;">{{$t("total")}}:
                        <strong><span
                                class="text-success">{{totalImporte | currency}}</span></strong></p>
                    <p style="font-size: 20px">{{$t("totalCoste")}}: <strong><span
                            class="text-danger">{{totalCoste | currency}}</span></strong>
                    </p>
                </div>

                <div class="col-md-6" style="margin-bottom: 1%">
                    <div class="progress" style="height: 45%">

                        <!--NEGATIVO-->
                        <div v-if="((totalCoste*100)/totalImporte)>0 && ((totalCoste*100)/totalImporte)<100"
                             class="progress-bar " style="background: #d9534f"
                             v-bind:style="{width: (totalCoste*100)/totalImporte + '%'}">
                            <span class="text-progressbar">{{((totalCoste*100)/totalImporte).toFixed(2)}} %</span>
                        </div>
                        <div v-else-if="((totalCoste*100)/totalImporte)>100" class="progress-bar "
                             style="background: #d9534f"
                             v-bind:style="{width: 100 + '%'}">
                            <span class="text-progressbar">100 %</span>
                        </div>
                        <div v-else-if="((totalCoste*100)/totalImporte)<0" class="progress-bar "
                             style="background: #d9534f"
                             v-bind:style="{width: 0 + '%'}">
                        </div>

                        <!--POSITIVO-->
                        <div v-if="100-(totalCoste*100)/totalImporte>0 && 100-(totalCoste*100)/totalImporte<100"
                             class="progress-bar " style="background: #5cb85c"
                             v-bind:style="{width: 100-(totalCoste*100)/totalImporte + '%'}">
                            <span class="text-progressbar">{{(100 - ((totalCoste*100)/totalImporte)).toFixed(2)}} %</span>
                        </div>

                        <div v-else-if="(100-(totalCoste*100)/totalImporte>100) || totalCoste===0"
                             class="progress-bar " style="background: #5cb85c"
                             v-bind:style="{width: 100 + '%'}">
                            <span class="text-progressbar">100 %</span>
                        </div>

                        <div v-else-if="100-(totalCoste*100)/totalImporte<0" class="progress-bar "
                             style="background: #5cb85c"
                             v-bind:style="{width: 0  + '%'}">

                        </div>
                    </div>

                    <p style="text-align: center">
                        <span style="background-color:#d9534f">&nbsp;&nbsp;&nbsp;</span>
                        {{$t("costes")}}
                        <span style="background-color:#5cb85c">&nbsp;&nbsp;&nbsp;</span>
                        {{$t("ventas")}}

                        <el-dropdown>
                            <el-button type="primary" size="small">
                                <i class="fa fa-file"></i>
                                {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <a :href="urlExportPDF">
                                    <el-dropdown-item class="text-danger">
                                        <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                    </el-dropdown-item>
                                </a>
                                
                                <a :href="urlExportExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                    </el-dropdown-item>
                                </a>

                                <a :href="urlExportSimplifiedExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarSimplifiedExcel")}}</strong>
                                    </el-dropdown-item>
                                </a>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button type="primary" size="small" @click="openModalCalcularCostoProductos()">  
                            <i class="el-icon-s-tools"></i> {{ $t('calcularCosteTodosLosProductos') }}
                        </el-button>
                    </p>
                </div>
            <div class="col-mb-40">
                <div class="row" style="padding-top:20px">
                    
                        <el-checkbox class="ivaCehckBox" v-model="sinIva">{{ $t('trabajarSinIva') }}</el-checkbox>
                        <p class="infoText">
                            {{ $t('filtrarPorAgencias') }}
                        </p>
                        <el-select 
                            class="select-default mb-2 filterTag"
                            size="large"
                            filterable
                            v-model="idFiltroAgencia"
                            placeholder="Filtrar por etiqueta"
                        >
                        <el-option 
                            v-for="agencia in listAgenciasFiltradas"
                            class="select-primary"
                            :value="agencia.id"
                            :label="agencia.name"
                            :key="agencia.id">
                        </el-option>
                        </el-select>
                        <!-- selleccionar tarifas --> 
                        <div class="col-md-20">
                            <div class="row" style="padding-left:20px">
                                <p class="infoText">
                                    <i v-tooltip.top-center="'Cambiar la tarifa seleccionada solo afecta al campo de coste por unidad'"
                                            style="cursor: pointer; padding:5px; color:#1E22AA;"
                                            class="fa fa-info-circle">
                                    </i>
                                    {{ $t('seleccioneLaTarifaParaMostrarSuNombre') }}
                                </p>
                                <div class="row">
                                    <div class="col-md-7">
                                        <el-select 
                                            class="select-default mb-2 filterTag"
                                            size="large"
                                            filterable
                                            v-model="selectedTarifa"
                                            placeholder="Tarifa 1"
                                            @change="getSalesProducts"
                                        ><!-- select cambia valor de v-model -->

                                            <el-option 
                                                v-for="item in tarifas" 
                                                class="select-primary"
                                                :value="item.label"
                                                :label="item.label" 
                                                :key="item.value" 
                                            > <!-- recorre con v-for tarifas por cada item y da valor a v-model con value-->
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>   
                            </div>
                        </div><!-- FIN selleccionar tarifas -->
                </div>
            </div>

                <div class="col-md-12">
                    <hr>
                </div>
                
                <div class="col-md-12" v-for="(a,indiceAgencia) in listAgencias" :key="a.indiceAgencia">
                    <template v-if="idFiltroAgencia == -1 || (idFiltroAgencia != -1 && idFiltroAgencia == a.id)">
                        <h4 class="wrapperNegocio" style="color:#444;"> <template v-if="a.nameAgencia != 'Sin agencias'">
                                <span >{{ $t('agencia') }}:</span>
                            </template> <span style=" font-weight:bold;">{{a.nameAgencia}}</span> ({{a.comensales}} {{$t('comensalesMinuscula') }})</h4>
                        <hr style="border-top: 1px solid rgba(0, 0, 0, 0.3);">
                        <div class="col-md-12" v-for="(p,indice) in a.categories" :key="p.id">
                            <h5 class="wrapperNegocio">{{p.name}}</h5>
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped text-nowrap">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th>
                                            <span v-if="ordenarProducto" @click="sortedArrayASC(1,indice,indiceAgencia),ordenarProducto=0">
                                                <i style="color: white" class="fa fa-angle-up"></i> 
                                                {{$t("producto")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(1,indice,indiceAgencia), ordenarProducto=1">
                                                <i style="color: white" class="fa fa-angle-down"></i> 
                                                {{$t("producto")}}
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarUds"
                                                @click="sortedArrayASC(2,indice,indiceAgencia),ordenarUds=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("uds")}}.
                                            </span>
                                            <span v-else @click="sortedArrayDESC(2,indice,indiceAgencia), ordenarUds=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("uds")}}.
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarCosteUd"
                                                @click="sortedArrayASC(3,indice,indiceAgencia),ordenarCosteUd=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("costeUd")}}.
                                            </span>
                                            <span v-else @click="sortedArrayDESC(3,indice,indiceAgencia), ordenarCosteUd=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("costeUd")}}.
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarImporte"
                                                @click="sortedArrayASC(4,indice,indiceAgencia),ordenarImporte=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(4,indice,indiceAgencia), ordenarImporte=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarPrecioMed"
                                                @click="sortedArrayASC(5,indice,indiceAgencia),ordenarPrecioMed=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("precioMed")}}.
                                            </span>
                                            <span v-else @click="sortedArrayDESC(5,indice,indiceAgencia), ordenarPrecioMed=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("precioMed")}}.
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarCoste"
                                                @click="sortedArrayASC(6,indice,indiceAgencia),ordenarCoste=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("coste")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(6,indice,indiceAgencia), ordenarCoste=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("coste")}}
                                            </span>
                                        </th>

                                        <th><span v-if="ordenarRentabilidad"
                                                @click="sortedArrayASC(9,indice,indiceAgencia),ordenarRentabilidad=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t('rentabilidad')}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(9,indice,indiceAgencia), ordenarRentabilidad=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t('rentabilidad')}}
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarPorcentajeCosto"
                                                @click="sortedArrayASC(7,indice,indiceAgencia),ordenarPorcentajeCosto=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("porcentajeCosto")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(7,indice,indiceAgencia), ordenarPorcentajeCosto=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("porcentajeCosto")}}
                                            </span>
                                        </th>

                                        <th>
                                            <span v-if="ordenarVarCosteMed"
                                                @click="sortedArrayASC(8,indice,indiceAgencia),ordenarVarCosteMed=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("varCostoMed")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(8,indice,indiceAgencia), ordenarVarCosteMed=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("varCostoMed")}}
                                            </span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="obj in p.products">
                                        <tr><!--:key="obj.id + Math.random()" Quitamos esta key porque hace que la pagina se vuelva a renderizar y por ello se pierde el focus en los inputs-->
                                            <td style="width: 30%;"> 
                                                <span style="color:#458195; cursor: pointer;" v-if="obj.productosMenu.length > 0" @click="abrirModalProductosMenu(obj)">⠀
                                                    <i class="fas fa-list" style="font-weight: bold; font-size: 1.1em"></i>
                                                        {{obj.name}}
                                                </span>
                                                <span v-else>{{obj.name}}</span> 
                                            </td>
                                            <td>{{obj.cantidad}}</td>
                                            <td align="right" width="8%">
                                                <input @blur="changeProduct(obj,p)"
                                                    class="form-control" type="number"
                                                    v-model="obj.costprice"/>
                                            </td>
                                            <td class="table-success" align="right">{{obj.importe | currency}}</td>
                                            <td align="right">{{obj.precioMed}} €</td>
                                            <td class="table-danger" align="right">{{obj.cost | currency}}</td>
                                            <td align="right">
                                            <template v-if="obj.costprice==0 && obj.cost==0">{{0}} %</template>
                                            <template v-else-if="obj.costprice!=0 && obj.cost!=0">{{((obj.importe - obj.cost) *100/ obj.cost).toFixed(2)}} % </template>
                                            <template v-else-if="obj.cost==0">0 %</template>
                                            <!-- <template v-else-if="obj.cost==0">{{0}} % </template> -->
                                            <!-- <template v-else><span
                                                    :class="{'text-danger':(obj.importe - obj.cost) *100/obj.cost<0}">{{((obj.importe - obj.cost) *100/ obj.cost).toFixed(2)}} % </span>
                                            </template> -->
                                            <template v-else><span
                                                    :class="{'text-danger':(obj.importe - obj.cost) *100/obj.cost<0}">{{((obj.importe - obj.cost) *100/ obj.cost).toFixed(2)}} % </span>
                                            </template>
                                            </td>
                                            <!--<td align="right">
                                            <span v-if="obj.importe===0 || obj.costprice===0">0%</span>
                                            <span class="text-success"
                                            v-else-if="(((obj.precioMed-obj.costprice)/obj.precioMed)*100) >0">{{(((obj.precioMed-obj.costprice)/obj.precioMed)*100).toFixed(2)}}</span>
                                            <span class="text-danger" v-else>{{(((obj.precioMed-obj.costprice)/obj.precioMed)*100).toFixed(2)}}</span>
                                            %
                                            </td>-->
                                            <td align="right">{{obj.porcenCosto}}%</td>
                                            <td align="right">
                                                    <span v-if="obj.varCost>0"
                                                        class="text-danger">+{{obj.varCost.toFixed(2)}}%</span>
                                                <span class="text-success"
                                                    v-else-if="obj.varCost<0">{{obj.varCost.toFixed(2)}}%</span>
                                                <span v-else>0%</span>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td class="table-success"><strong>{{$t("total")}}</strong></td>
                                        <td class="table-success"><strong>{{getTotalUds(p)}}</strong></td>
                                        <td class="table-success"></td>
                                        <td class="text-right table-success"><strong>{{getTotalImporte(p) |
                                            currency}}</strong></td>
                                        <td class="table-success"></td>
                                        <td class="text-right table-danger"><strong>{{getTotalCoste(p) | currency}}</strong>
                                        </td>
                                        <td class="text-right table-success"><strong>{{getTotalRentabilidad(p)}} %</strong>
                                        </td>
                                        <td class="text-right table-success"><strong>{{getTotalPorcenCoste(p)}} %</strong>
                                        </td>
                                        <td class="table-success"></td>

                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- inicio TOTAL-->
                <div class="col-md-12" v-if="idFiltroAgencia!=-1">
                    <template >
                        <h4 class="wrapperNegocio" style="color:#444;"> <template>
                                <p style="font-size: 20px; margin-bottom: 10px;">{{$t("total")}}:
                        <strong><span
                                class="text-success">{{getTotalImporteAgencia(idFiltroAgencia) | currency}}</span></strong></p>
                                <!-- <p style="font-size: 20px">{{$t("totalCoste")}}: <strong><span
                                class="text-danger">{{totalCoste | currency}}</span></strong>
                                    </p>-->
                            </template> <!--<span style=" font-weight:bold;">{{a.nameAgencia}}</span>--></h4>
                        <hr style="border-top: 1px solid rgba(0, 0, 0, 0.3);">

                    </template>
                </div>
                <!-- fin  -->
            </template>
            <template v-else>
                <div class="col-md-12">
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHayVentasDeProductosEnEsteRangoDeFechas")}}
                    </div>
                </div>

            </template>
            <modal name="modal-calcular-costo" :adaptive=true :scrollable=true height="auto"
                    :clickToClose=true>
                <div>
                    <div class="modal-header wrapperTitle">
                        <h4 style="margin: 0px">{{ $t('calcularCosteTodosLosProductos') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <el-checkbox v-model="calcularConIva">{{ $t('conIVA') }}</el-checkbox>
                                <el-checkbox v-model="calcularSinIva">{{ $t('sinIVA') }}</el-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button @click="calcularCostos()" :disabled="!calcularConIva && !calcularSinIva" style="background-color:#007bff;border-color:#007bff;" class="btn btn-primary"><i
                                    class="fa fa-check"></i>
                                {{ $t('calcular') }}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
            <modal
                name="detallesMenu"
                :adaptive="true"
                :scrollable="true"
                height="auto"
                :clickToClose="true"
            >
            <div>
                <div class="modal-header">
                <h4 style="margin: 0px">
                    {{ $t('productosIncluidosConEsteMenu') }}
                </h4>
                </div>
                <div class="modal-body">
                <div
                    class="table-responsive"
                    style="overflow: auto"
                >
                    <table class="table table-bordered table-striped ">
                    <thead class="thead-dark">
                        <tr>
                        <th style="width:90%">{{ $t("nombre") }}</th>
                        <th>{{ $t("cantidad") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(prod) in listaDetallesMenu" :key="prod.id + Math.random()">
                            <td>{{prod.name}}</td>
                            <td>{{prod.cantidad}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr></tr>
                    </tfoot>
                    </table>
                </div>
                </div>
                <div class="modal-footer">
                <button class="btn btn-default" @click="cerrarModalProductosMenu()">
                    <i class="fa fa-times-circle"></i>
                    {{ $t("cerrar") }}
                </button>
                </div>
            </div>
            </modal>
            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{tpv.nameShow}}
                            </el-checkbox>
                        </el-checkbox-group>

                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getSalesProducts()"><i class="fa fa-search"></i>
                                {{$t("filtrarTPV")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>
<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup,
        Loading
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import bus from '../../../../bus'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t("costeDeProductosPorAgencias"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

            bus.$on('get-ventas', (item) => {
                this.getVentas();
            });

            bus.$on('get-business', (idBusiness) => {
                this.idBusiness = idBusiness;
                this.idsTPV = [];
                this.idTpv = 0;

                this.getTpv();
            });

            bus.$on('get-tpv', (idTpv) => {
                this.idTpv = idTpv;

                this.changeTPV();
            });

            bus.$on('get-date', (dates) => {
                this.value4 = dates;

                this.getSalesProducts();
            });

            bus.$on('get-open-modal', (item) => {
                this.openModal();
            });
        },
        components: {
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                listAgencias: [],
                mode: 0,
                $Chart: null,
                objectChart: null,
                contador: 0,
                chartIn: 0,
                listTpv: [],
                idTpv: 0,
                sinIva: false,
                dateRangeOptions1: {
                    firstDayOfWeek: 1

                },
                hoursfrom: "00:00:00",
                hoursto: "23:59:59",
                listCheckBoxTpv: [],
                idsTPV: [],

                totalImporte: 0,
                totalCoste: 0,

                totalImporteAgencia: 0,
                totalCosteAgencia: 0,
                busquedaPorHoras: false,
                //ORDENAR
                ordenarProducto: 0,
                ordenarUds: 0,
                ordenarCosteUd: 0,
                ordenarImporte: 0,
                ordenarPrecioMed: 0,
                ordenarCoste: 0,
                ordenarPorcentajeCosto: 0,
                ordenarVarCosteMed: 0,
                ordenarRentabilidad: 0,

                respuesta:true,
                listaDetallesMenu: [],
                calcularSinIva: false,
                calcularConIva: false,
                idFiltroAgencia: -1,
                listAgenciasFiltradas: [],
                selectedTarifa: "Tarifa 1",
                tarifas: [
                            { value: '1', label: "Tarifa 1" },
                            { value: '2', label: "Tarifa 2" },
                            { value: '3', label: "Tarifa 3" },
                            { value: '4', label: "Tarifa 4" },
                        ],
            }
        },
        watch: {
            sinIva (value) {
                this.getSalesProducts();
            }, 
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/products/exportSalesProductsAvanzadosAgencias/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&sinIva="+this.sinIva+"&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&filterByHours=" + this.busquedaPorHoras + "&tarifa=" + this.selectedTarifa + "&jwt=" + this.$store.getters.jwt;
            },
            urlExportExcel() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });
            
                return this.$store.getters.apiUrl+"/products/exportSalesProductsAvanzadosAgencias/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&sinIva="+this.sinIva+"&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix()+ "&hoursfrom=" +  this.hoursfrom + "&hoursto=" +  this.hoursto  + "&filterByHours=" + this.busquedaPorHoras + "&idAgencia=" + this.idFiltroAgencia + "&tarifa=" + this.selectedTarifa + "&jwt=" + this.$store.getters.jwt;
            },          
            urlExportSimplifiedExcel() {
            var tpv = "";

            this.idsTPV.forEach(function (d) {
                tpv += d + ',';
            });
            
            return this.$store.getters.apiUrl+"/products/exportSimplifiedSalesProductsAvanzadosAgencias/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&sinIva="+this.sinIva+"&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix()+ "&hoursfrom=" +  this.hoursfrom + "&hoursto=" +  this.hoursto  + "&filterByHours=" + this.busquedaPorHoras + "&idAgencia=" + this.idFiltroAgencia + "&tarifa=" + this.selectedTarifa + "&jwt=" + this.$store.getters.jwt;
            },      
        },
        methods: {
            abrirModalProductosMenu(prod) {
                this.listaDetallesMenu = prod.productosMenu;
                this.$modal.show('detallesMenu');
            },
            cerrarModalProductosMenu() {
                this.$modal.hide('detallesMenu');
                this.listaDetallesMenu = [];
            },
            openModalCalcularCostoProductos() {
                this.calcularConIva = false;
                this.calcularSinIva = false;
                this.$modal.show('modal-calcular-costo');
                
            },
            calcularCostos() {

                this.loading = Loading.service({ text: "Cargando..." });

                if (this.calcularConIva) {                       
                    
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idTpv: this.idTpv == -1 ? this.listTpv[0].id : this.idTpv,
                        sinIva: false,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    this.axios.post(this.$store.getters.apiUrl + "products/calculateProductsCosts", params, config)
                        .then(function (response) {
                            if (response.data.response) {
                                
                                vm.$notify({
                                    message: 'Costes actualizados',
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.$modal.hide('modal-calcular-costo');

                                if (!vm.calcularSinIva) {
                                    vm.getSalesProducts();
                                }
                                
                            } else {

                                vm.loading.close();

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

                if (this.calcularSinIva) {
                    
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idTpv: this.idTpv == -1 ? this.listTpv[0].id : this.idTpv,
                        sinIva: true,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    this.axios.post(this.$store.getters.apiUrl + "products/calculateProductsCosts", params, config)
                        .then(function (response) {
                            if (response.data.response) {
                                
                                vm.$notify({
                                    message: 'Costes actualizados',
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.$modal.hide('modal-calcular-costo');
                                
                                vm.getSalesProducts();

                            } else {

                                vm.loading.close();

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },
            cambioBuscarPorHoras(bpH) {
                this.busquedaPorHoras = bpH;
                
            },
            cambioHorasBusqueda(hoursfrom, hoursto) {
                this.hoursfrom = moment(hoursfrom).format("HH:mm:ss");
                this.hoursto = moment(hoursto).format("HH:mm:ss");
            },
            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }

                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.idsTPV = [];
                this.list = [];
                this.cambioTpv(this.idTpv);
            },
            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                this.getSalesProducts();
            },
            cambioTpv(idTpvData, filtrar) {
                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;

                    this.changeTPV();
                }

                this.idTpv=idTpvData;
                this.emitirConsulta();
            },
            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]
            },
            getTotalUds(obj) {
                let total = 0;
                obj.products.forEach(function (d) {
                    total += d.cantidad;
                });
                return total;
            },
            getTotalImporte(obj) {
                let total = 0;
                obj.products.forEach(function (d) {
                    total += d.importe;
                });
                return total;
            },
            getTotalImporteAgencia(idFiltroAgencia){
                let totalImporteAgencia=0;
                
                this.listAgencias.forEach(function (a) {
                    if(a.id==idFiltroAgencia){
                    a.categories.forEach(function (l) {
                        l.products.forEach(function (le) {
                            totalImporteAgencia += le.importe;
                        });
                    });}
                });
                return parseFloat(totalImporteAgencia);
            },
            getTotalCoste(obj) {
                let total = 0;
                obj.products.forEach(function (d) {
                    total += d.cost;
                });
                return total;
            },
            
            getTotalPorcenCoste(obj) {
                let total = 0;
                obj.products.forEach(function (d) {
                    total += d.porcenCosto;
                });
                return Math.round(total / obj.products.length * 100) / 100;
            },
            getTotalRentabilidad(obj) {
                let total = 0;
                let resultado = 0;
                obj.products.forEach(function (d) {

                    if (d.cost !== 0) {
                        total += ((d.importe - d.cost) * 100 / d.cost);
                    } else {
                        total = total + 0;
                    }

                });

                return Math.round(total / obj.products.length * 100) / 100;
            },
            sortedArrayASC: function (nameAtributo, index, indexAgencia) {
                switch (nameAtributo) {

                    case 1:

                        this.ordenarProducto = 1;

                        function compareName(a, b) {

                            if (a.name.toUpperCase() < b.name.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() > b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareName);

                    case 2:

                        this.ordenarUds = 1;

                        function compareUds(a, b) {

                            if (parseFloat(a.cantidad) < parseFloat(b.cantidad))
                                return -1;
                            if (parseFloat(a.cantidad) > parseFloat(b.cantidad))
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareUds);

                    case 3:

                        this.ordenarCosteUd = 1;

                        function compareCosteUd(a, b) {

                            if (a.costprice < b.costprice)
                                return -1;
                            if (a.costprice > b.costprice)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareCosteUd);

                    case 4:

                        this.ordenarImporte = 1;

                        function compareImporte(a, b) {

                            if (a.importe < b.importe)
                                return -1;
                            if (a.importe > b.importe)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareImporte);

                    case 5:

                        this.ordenarPrecioMed = 1;

                        function comparePrecioMed(a, b) {

                            if (a.precioMed < b.precioMed)
                                return -1;
                            if (a.precioMed > b.precioMed)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(comparePrecioMed);

                    case 6:

                        this.ordenarCoste = 1;

                        function compareCoste(a, b) {

                            if (a.cost < b.cost)
                                return -1;
                            if (a.cost > b.cost)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareCoste);
                    case 7:

                        this.ordenarPorcentajeCosto = 1;

                        function comparePorcentajeCoste(a, b) {

                            if (a.porcenCosto < b.porcenCosto)
                                return -1;
                            if (a.porcenCosto > b.porcenCosto)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(comparePorcentajeCoste);
                    case 8:

                        this.ordenarVarCosteMed = 1;

                        function compareVarCostoMed(a, b) {

                            if (a.varCost < b.varCost)
                                return -1;
                            if (a.varCost > b.varCost)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareVarCostoMed);

                    case 9:

                        this.ordenarRentabilidad = 1;

                        function compareRentabilidad(a, b) {

                            if(a.costprice===0){
                                return -1;
                            } else if(b.costprice===0){
                                return 1;
                            } else if (((a.importe - a.cost) * 100 / a.cost) < ((b.importe - b.cost) * 100 / b.cost))
                                return -1;

                            if (((a.importe - a.cost) * 100 / a.cost) > ((b.importe - b.cost) * 100 / b.cost))
                                return 1;
                            return 0;
                        }
                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareRentabilidad);
                }
            },
            sortedArrayDESC: function (nameAtributo, index, indexAgencia) {
                switch (nameAtributo) {

                    case 1:

                        this.ordenarProducto = 0;

                        function compareName(a, b) {

                            if (a.name.toUpperCase() > b.name.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() < b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareName);

                    case 2:

                        this.ordenarUds = 0;

                        function compareUds(a, b) {

                            if (parseFloat(a.cantidad) > parseFloat(b.cantidad))
                                return -1;
                            if (parseFloat(a.cantidad) < parseFloat(b.cantidad))
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareUds);

                    case 3:

                        this.ordenarCosteUd = 0;

                        function compareCosteUd(a, b) {

                            if (a.costprice > b.costprice)
                                return -1;
                            if (a.costprice < b.costprice)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareCosteUd);

                    case 4:

                        this.ordenarImporte = 0;

                        function compareImporte(a, b) {

                            if (a.importe > b.importe)
                                return -1;
                            if (a.importe < b.importe)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareImporte);

                    case 5:

                        this.ordenarPrecioMed = 0;

                        function comparePrecioMed(a, b) {

                            if (a.precioMed > b.precioMed)
                                return -1;
                            if (a.precioMed < b.precioMed)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(comparePrecioMed);

                    case 6:

                        this.ordenarCoste = 0;

                        function compareCoste(a, b) {

                            if (a.cost > b.cost)
                                return -1;
                            if (a.cost < b.cost)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareCoste);

                    case 7:

                        this.ordenarPorcentajeCosto = 0;

                        function comparePorcentajeCoste(a, b) {

                            if (a.porcenCosto > b.porcenCosto)
                                return -1;
                            if (a.porcenCosto < b.porcenCosto)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(comparePorcentajeCoste);

                    case 8:

                        this.ordenarVarCosteMed = 0;

                        function compareVarCostoMed(a, b) {

                            if (a.varCost > b.varCost)
                                return -1;
                            if (a.varCost < b.varCost)
                                return 1;
                            return 0;
                        }

                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareVarCostoMed);

                    case 9:
                        this.ordenarRentabilidad = 0;

                        function compareRentabilidad(a, b) {

                            if(a.costprice===0){
                                return 1;
                            } else if(b.costprice===0){
                                return -1;
                            } else if ((a.importe - a.cost) * 100 / a.cost > (b.importe - b.cost) * 100 / b.cost)
                                return -1;

                            if ((a.importe - a.cost) * 100 / a.cost < (b.importe - b.cost) * 100 / b.cost)
                                return 1;
                            return 0;
                        }
                        return this.listAgencias[indexAgencia].categories[index].products.sort(compareRentabilidad);
                }
            },
            changeProduct(p, obj) {
                this.totalImporte = 0;
                this.totalCoste = 0;
                let vm = this;
                let costoCat = 0;
                let varMed = 0;
                p.cost = (p.costprice * p.cantidad);

                if (p.importe === 0) {
                    p.porcenCosto = 0;
                } else {
                    p.porcenCosto = Math.round(((p.costprice * p.cantidad) / p.importe * 100) * 100) / 100;
                }

                this.listAgencias.forEach(function (a) {
                    a.categories.forEach(function (l) {
                        l.products.forEach(function (le) {
                            vm.totalImporte += le.importe;
                            vm.totalCoste += le.cost;
                        });
                    });
                });

                obj.products.forEach(function (ob) {

                    if (ob.importe !== 0) {
                        costoCat += (ob.cost * 100) / ob.importe / obj.products.length;
                    } else {
                        costoCat += ob.cost * 100 / obj.products.length;
                    }

                });

                if (p.importe !== 0) {
                    p.varCost = Math.round((((p.cost * 100) / p.importe) - costoCat) * 100) / 100;
                } else {
                    p.varCost = (p.cost * 100) - costoCat;
                }

                if (vm.sinIva) {
                    this.updateCostSinIVA(p);
                } else {
                    this.updateCost(p);
                }   
            },
            updateCost(p) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                var params = {
                    idProduct: p.idProduct,
                    tarifa: this.selectedTarifa, //tarifa seleccionada, por defecto Tarifa 1
                    cost: p.costprice,
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                let controller = "updateCost";
                this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {
                            let notify = vm.$t("actualizado");
                            vm.$notify({
                                message: vm.$t('coste')+' ' + notify + ' '+vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            updateCostSinIVA(p) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                var params = {
                    idProduct: p.idProduct,
                    cost: p.costprice,
                    tarifa: this.selectedTarifa, //tarifa seleccionada, por defecto Tarifa 1
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                let controller = "updateCostNoIVA";
                this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {
                            let notify = vm.$t("actualizado");
                            vm.$notify({
                                message: vm.$t('coste')+' ' + notify + ' '+vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            changeTPV() {
                if (this.idTpv === -1) {
                    this.idsTPV = [];

                    for (let i = 0; i < this.listTpv.length; i++) {
                        this.idsTPV.push(this.listTpv[i].id);
                    }

                } else {
                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)
                }
            },
            openModal() {
                this.$modal.show('filtradoTPV');
            },
            getTpv() {
                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {
                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;

                            for (let i = 0; i < response.data.result.length; i++) {

                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getSalesProducts();
                        }
                        vm.loading = false;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesProducts() {
                this.$modal.hide('filtradoTPV');

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    
                    this.loading.close();
                } else {
                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

            
                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.loading.close();
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                idTpv: this.idsTPV,
                                tarifa: this.selectedTarifa, //tarifa seleccionada, por defecto Tarifa 1
                                filterByHours: this.busquedaPorHoras,
                                hoursFrom : this.hoursfrom,
                                hoursTo : this.hoursto,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "products/getSalesProductsAvanzadoAgencias", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.respuesta=true;
                                    vm.listAgencias = [];
                                    vm.listAgenciasFiltradas = [];
                                    vm.totalImporte = 0;
                                    vm.totalCoste = 0;

                                    let AgenciaFiltrada = {
                                        id: -1,
                                        name: "Todas las agencias"
                                    }

                                    vm.listAgenciasFiltradas.push(AgenciaFiltrada);

                                    response.data.result.forEach(function (a) {

                                        let AgenciaFiltrada = {
                                            id: a.id,
                                            name: a.nameAgencia
                                        }

                                        vm.listAgenciasFiltradas.push(AgenciaFiltrada);
                                        
                                        vm.list = [];

                                        a.categories.forEach(function (d) {
                                            
                                            let xarray = [];
                                            let costoCat = 0;
                                            let varMed = 0;

                                            d.products.forEach(function (p) {
                                                //Si quiere verlo sin IVA, se lo descuento
                                                if (p.cantidad > 0) {

                                                    if (vm.sinIva) {
                                                        //p.cost = p.cost - (p.cost * p.iva / 100);
                                                        //p.cost = p.cost / (p.iva / 100 + 1);
                                                        p.costprice = p.costpriceSinIVA;
                                                        p.precioMed = p.precioMedSinIVA.toFixed(4).replace(".", ",");
                                                        p.cost = p.cantidad * p.costpriceSinIVA;
                                                        p.importe = p.importe / (p.iva / 100 + 1);
                                                        p.porcenCosto = p.porcenCostoSinIVA;
                                                    } else {
                                                        p.precioMed = p.precioMed.toFixed(4).replace(".", ",");
                                                    }
                                                    if (p.importe !== 0) {
                                                        costoCat += (p.cost * 100) / p.importe / d.products.length;
                                                    } else {
                                                        costoCat += p.cost * 100 / d.products.length;
                                                    }

                                                    vm.totalImporte += parseFloat(p.importe);
                                                    vm.totalCoste += parseFloat(p.cost);

                                                }
                                            });

                                            d.products.forEach(function (p) {

                                                if (p.cantidad > 0) {
                                                    if (p.importe !== 0) {
                                                        varMed = ((p.cost * 100) / p.importe) - costoCat;
                                                    } else {
                                                        varMed = (p.cost * 100) - costoCat;
                                                    }

                                                    let xdate = {
                                                        "id": p.id,
                                                        "idProduct": p.idProduct,
                                                        "name": p.name,
                                                        "precioMed": p.precioMed,
                                                        "costprice": p.costprice,
                                                        "costpriceSinIVA": p.costpriceSinIVA,
                                                        "importe": p.importe,
                                                        "cost": p.cost,
                                                        "cantidad": p.cantidad,
                                                        "porcenCosto": Math.round(p.porcenCosto * 100) / 100,
                                                        "varCost": Math.round(varMed * 100) / 100,
                                                        "iva": p.iva,
                                                        "isMenu" : p.isMenu,
                                                        "productosMenu" : p.productosMenu
                                                    };

                                                    xarray.push(xdate);
                                                }
                                                
                                            });

                                            let xDate = {
                                                "name": d.name,
                                                "products": xarray,
                                            };

                                            vm.list.push(xDate);

                                        });

                                        let xAgencia = {
                                            "id": a.id,
                                            "nameAgencia": a.nameAgencia,
                                            "categories": vm.list,
                                            "comensales": a.comensales
                                        };

                                        vm.listAgencias.push(xAgencia);

                                    });
                                } else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });
                                    vm.respuesta = false;
                                } else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta=false;
                                }
                                vm.loading.close();
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
        }
    }
</script>
<style scoped>
    .text-progressbar {
        font-weight: bold;
        font-size: 1.3em;
        text-shadow: 1px 1px #111111;
    }
    a li {
        color: #111;
    }
    .card {
        padding: 20px;
    }
    .div-export {
        margin-bottom: 10px;
    }
    .infoText {
        font-size: 85%;
        padding-right: 10px;
        padding-left: 30px;
        padding-top: 9px;
        color: rgb(109, 109, 109);
    }
    .ivaCehckBox {
        color: rgb(109, 109, 109);
        padding-top: 9px;
        padding-left: 30px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/EstadisticasAvanzadasAgencias.vue